import { withIconHOC } from '@components/std-components/Icons'
import { CardIcon, KPIIcon, ListIcon } from '../resources'
import { nav } from '@stores'
import { getEnumValue } from '@utils/get-enum-value'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { CardGalleryIcon } from '@components/UI-Components/svg'
export enum View {
  Product = 'Product',
  KPI = 'KPI',
  List = 'List',
  AddProduct = 'AddProduct'
}

export enum ViewModes {
  Warning = 'Warning',
  InitialAllocation = 'InitialAllocation'
}

// TODO: Add translation keys
export const ViewMapping = {
  Product: 'Card View',
  List: 'List View',
  KPI: 'KPI View',
  Quantity: 'Quantity View'
}

export const ViewIconMapping = {
  Product: withIconHOC({ imageSrc: CardIcon }),
  List: withIconHOC({ imageSrc: ListIcon }),
  KPI: withIconHOC({ imageSrc: KPIIcon })
}

export const EnhancedViewIconMapping = {
  Product: withIconHOC({ imageSrc: CardGalleryIcon }),
  List: withIconHOC({ imageSrc: ListIcon }),
  KPI: withIconHOC({ imageSrc: KPIIcon })
}

export const getViews = t => {
  const clientType = nav.queryParams.clientType
  return [
    {
      id: View.Product,
      name: t('common.views.cardView', 'Card View'),
      icon: ViewIconMapping[View.Product]
    },
    {
      id: View.List,
      name:
        clientType === getEnumValue(VIPClientType.Internal)
          ? t('common.views.listView', 'List View')
          : t('common.views.quantityView', 'Quantity View'),
      icon: ViewIconMapping[View.List]
    },
    {
      id: View.KPI,
      name: t('common.views.KPIView', 'KPI View'),
      icon: ViewIconMapping[View.KPI]
    }
  ]
}

export const viewToConfigMapping = {
  [View.Product]: 'orderCollection',
  [View.KPI]: 'KPIView',
  [View.List]: 'listOrderCollection',
  [View.AddProduct]: 'addProductViewCollection'
}
